export default __webpack_public_path__ + "static/media/waterfall_768.79938558.webp";